import React, {useState, useRef, useEffect } from "react";
import {is} from 'ramda'
import {useIntl} from 'gatsby-plugin-intl';
import {
  Container,
  Header,
  Title,
  Navigation,
  Button,
  PreviousArrowIcon,
  NextArrowIcon,
  Card,
  CardContent,
  CardContentWrapper,
  Slider,
  CardHeaderContainer,
  CardWrapper,
  TimeBarContainer,
  TimeBarSVG,
  DateHeader,
  TimeDot,
  TimeBar,
  ExpandButton
} from './timeline.styles'
import { renderWhenTrue } from '../../utils/rendering';
import { CustomTooltip } from '../customTooltip'



const renderTooltip = (connection, citation) => {
  return (
    <CustomTooltip connection={connection} citation={citation} />
  )
}

const renderCardContent = ({ type, value }, key) => {
  if (!value || !is(String, value)) return null;
  const intl = useIntl();
  return (
    <CardContent type={type} key={key}>
      {intl.formatMessage({ id: value })}
    </CardContent>
  );
};

const renderCardHeader = (cardDate, connection, citation) => {
  const intl = useIntl();
  if(!cardDate.value && !connection.value && !citation.value) return null
  return (
    <CardHeaderContainer>
      <CardContent>
        {intl.formatMessage({ id: cardDate.value })}
      </CardContent>
      {renderTooltip(connection, citation)}
    </CardHeaderContainer>
  )
}

export const ExpandableTimelineCard = ({ cardDate, markdown, connection, citation }) => {
  const [expand, setExpand] = useState(false)
  const [isClamped, setIsClamped] = useState(false)
  const contentRef = useRef()
  const { formatMessage } = useIntl();

  useEffect(() => {
    const scrollHeight = contentRef.current.children[1].scrollHeight
    const clientHeight = contentRef.current.children[1].clientHeight
    if(clientHeight < scrollHeight) setIsClamped(true)
  }, [])

  const handleExpand = () => {
    setExpand(!expand)
  }

  if(!markdown.value || !is(String, markdown.value)) return null

  return (
    <Card className={expand ? 'hidden' : null} ref={contentRef}>
      {renderCardHeader(cardDate, connection, citation)}
      <CardContent className={expand ? 'hidden' : null} >
        {formatMessage({ id: markdown.value })}
      </CardContent>
      {isClamped ? 
        <ExpandButton onClick={handleExpand}>
          { expand ? formatMessage({ id: 'Show Less'}) : formatMessage({ id: 'Show More'})}
        </ExpandButton> 
        : null }
    </Card>
  )
}

export default ExpandableTimelineCard